const productDetailsContainer = document.querySelector(".product-details-container");
const stickyCheckoutWrapper = document.querySelector(".sticky-checkout-wrapper");
const stickyCheckoutPriceWrapper = document.querySelector(".sticky-checkout__price");
const stickyCheckoutPricePerSmoothieWrapper = document.querySelector(".sticky-checkout__price-per-smoothie");
const stickyCheckoutFrequencyText = document.querySelector(".sticky-checkout__price-monthly");
const boosterInputs = [...document.querySelectorAll(".booster__input")];
const monthlyFrequency = document.querySelector("#frequency-monthly");
const oneTimePrice = parseInt(document.querySelector("#one-time-price")?.innerText);
const monthlyPrice = parseInt(document.querySelector("#monthly-price")?.innerText);

document.addEventListener("DOMContentLoaded", () => {
  let checkedCount = 0;
  boosterInputs.forEach((boosterInput) => {
    if (boosterInput.checked) {
      const targetBoosterId = boosterInput.dataset.boosterId;
      const targetStickyCheckoutIcon = document.querySelector(`.sticky-checkout__icon__${targetBoosterId}`);
      stickyCheckoutWrapper.classList.add("unselected");
      targetStickyCheckoutIcon.classList.remove("hidden");
      checkedCount++;
    }
  });
  const totalPrice = monthlyPrice + checkedCount * 5;
  if (stickyCheckoutPriceWrapper) {
    stickyCheckoutPriceWrapper.textContent = `$${totalPrice}`;
  }
  if (stickyCheckoutPricePerSmoothieWrapper) {
    stickyCheckoutPricePerSmoothieWrapper.textContent = `$${totalPrice / 25}`;
  }
});

productDetailsContainer.addEventListener("click", (event) => {
  const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  let monthlyFrequencyLabel = "/month"
  if (screenWidth > 750) {
    monthlyFrequencyLabel = "per month"
  }

  if (event.target.closest(".flavor__label") || event.target.closest(".variant__label") || event.target.closest(".frequency__label")) {
    stickyCheckoutWrapper.classList.add("unselected");
  }
  if (event.target.closest(".booster__label")) {
    const price = monthlyFrequency.checked ? monthlyPrice : oneTimePrice;
    const frequencyText = monthlyFrequency.checked ? monthlyFrequencyLabel : "one-time";
    const targetBoosterId = event.target.closest(".booster__label").dataset.boosterId;
    const targetInputEl = document.querySelector(`#booster-${targetBoosterId}`);
    const targetStickyCheckoutIcon = document.querySelector(`.sticky-checkout__icon__${targetBoosterId}`);
    setTimeout(function () {
      targetInputEl.checked
        ? targetStickyCheckoutIcon.classList.remove("hidden")
        : targetStickyCheckoutIcon.classList.add("hidden");

      let checkedCount = 0;
      boosterInputs.forEach((boosterInput) => {
        boosterInput.checked && checkedCount++;
      });
      const totalPrice = price + checkedCount * 5;
      if (stickyCheckoutPriceWrapper) {
        stickyCheckoutPriceWrapper.textContent = `$${totalPrice}`;
      }
      if (stickyCheckoutPricePerSmoothieWrapper) {
        stickyCheckoutPricePerSmoothieWrapper.textContent = `$${totalPrice / 25}`;
      }
      if (stickyCheckoutFrequencyText) {
        stickyCheckoutFrequencyText.textContent = frequencyText;
      }
    }, 0);
  }

  if (event.target.closest(".frequency__label")) {
    setTimeout(function () {
      const price = monthlyFrequency.checked ? monthlyPrice : oneTimePrice;
      const frequencyText = monthlyFrequency.checked ? monthlyFrequencyLabel : "one-time";

      let checkedCount = 0;
      boosterInputs.forEach((boosterInput) => {
        boosterInput.checked && checkedCount++;
      });
      const totalPrice = price + checkedCount * 5;
      if (stickyCheckoutPriceWrapper) {
        stickyCheckoutPriceWrapper.textContent = `$${totalPrice}`;
      }
      if (stickyCheckoutPricePerSmoothieWrapper) {
        stickyCheckoutPricePerSmoothieWrapper.textContent = `$${totalPrice / 25}`;
      }
      if (stickyCheckoutFrequencyText) {
        stickyCheckoutFrequencyText.textContent = frequencyText;
      }
    }, 0);
  }
});
